import { render, staticRenderFns } from "./BraSizeChart.vue?vue&type=template&id=e41f336a&"
import script from "./BraSizeChart.vue?vue&type=script&lang=js&"
export * from "./BraSizeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports